import React from "react";

// Component for handling modal functionality
const RecommendationInfo = ({ optimalRange, recommendation, explanation }) => {
    return (
        <>
            <p><strong>Optimal Range: </strong>{optimalRange}</p>
            <p><strong>Explanation: </strong>{explanation}</p>
            <p><strong>Recommendation: </strong>{recommendation}</p>
        </>
    );
};

export default RecommendationInfo;